import {
  CabitalAssetsConfigRes,
  EditProfileModel,
  LoginModel,
  RegisterModel,
  UploadResModel,
  UserModel,
  DiscordBindInfo,
} from 'services/types/User'
import request from 'services/request'
import { ResponseBase } from 'services/responseBase'
import { bcryptPassword } from 'utils'

// 获取公钥
export function basePublicKey(): Promise<ResponseBase> {
  return request.post<ResponseBase>('base/v1/public/key')
}

// 注册
export function register(data: RegisterModel, publicKey: string): Promise<ResponseBase> {
  data.password = bcryptPassword(data.password, publicKey)
  return request.post<ResponseBase>('user/v1/register', data)
}

// 登录
export function login(data: LoginModel, publicKey: string, deviceid?: string): Promise<ResponseBase> {
  data.password = bcryptPassword(data.password, publicKey)
  return request.post<ResponseBase>('user/v1/login', data, { headers: { deviceid: deviceid || '' } })
}

// 获取用户信息
export function getProfileInfo(): Promise<ResponseBase> {
  return request.post<ResponseBase<UserModel>>('profile/v1/user/info')
}

// 忘记密码发邮件
export function forgotPasswordStepOne(account: string): Promise<ResponseBase> {
  return request.post<ResponseBase>('profile/v1/findpassword', { account })
}

// 修改个人信息
export function editProfile(data: EditProfileModel): Promise<ResponseBase> {
  return request.post<ResponseBase>('profile/v1/edit', data)
}

// 修改个人信息
export function upload(type: string, data: FormData): Promise<ResponseBase> {
  return request.post<ResponseBase<UploadResModel>>(`profile/v1/uploader/${type}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 退出登录
export function logout(): Promise<ResponseBase> {
  return request.post<ResponseBase>('user/v1/logout')
}

// 验证用户密码
export function validUserPassWord(): Promise<ResponseBase> {
  return request.get<ResponseBase<CabitalAssetsConfigRes>>('profile/v1/validUserPassWord')
}

// 设置初始化密码
export function createPassword(password: string, publicKey: string, recaptchaToken: string): Promise<ResponseBase> {
  password = bcryptPassword(password, publicKey)
  return request.post<ResponseBase>(`profile/v1/setInitUserPassWord`, { password, recaptchaToken })
}

// 修改密码
export function updatePassword(
  oldPassword: string,
  password: string,
  publicKey: string,
  recaptchaToken: string
): Promise<ResponseBase> {
  password = bcryptPassword(password, publicKey)
  oldPassword = bcryptPassword(oldPassword, publicKey)
  return request.post<ResponseBase>(`profile/v1/password_edit`, { oldPassword, password, recaptchaToken })
}

// 忘记密码重置
export function passwordResetConfirm(resetCode: string, password: string, publicKey: string): Promise<ResponseBase> {
  password = bcryptPassword(password, publicKey)
  return request.post<ResponseBase>(`profile/v1/password_reset_confirm`, { resetCode, password })
}

// 注册重新发密码
export function resendEmail(username: string): Promise<ResponseBase> {
  return request.post<ResponseBase>(`user/v1/resend/mail`, { username })
}

// 重置密码重新发密码
export function passwordResendEmail(account: string): Promise<ResponseBase> {
  return request.post<ResponseBase>(`profile/v1/findpassword/resend_mail`, { account })
}

// 绑定社交
export function socialBind(type: string, businessType?: number): Promise<ResponseBase> {
  if (businessType) {
    return request.get<ResponseBase>(`profile/v1/bind/${type}?businessType=${businessType}`)
  } else {
    return request.get<ResponseBase>(`profile/v1/bind/${type}`)
  }
}

// 解绑社交
export function socialUnBind(type: string): Promise<ResponseBase> {
  return request.get<ResponseBase>(`profile/v1/unbind/${type}`)
}

// 绑定回调
export function socialBindCallBack(type: string, params: string): Promise<ResponseBase> {
  return request.get<ResponseBase>(`profile/v1/call_back/${type}${params}`)
}

// 邮箱验证
export function emailVerify(): Promise<ResponseBase> {
  return request.post<ResponseBase>(`user/v1/email/verify`)
}

// 获取币种配置信息列表
export function assetsConfig(): Promise<ResponseBase> {
  return request.get<ResponseBase<CabitalAssetsConfigRes>>('assets/amount/v1/config')
}

// 查询discord账号是否绑定
export function getDiscordBindInfo(accountId: string): Promise<ResponseBase> {
  return request.get<ResponseBase<DiscordBindInfo>>(`profile/v1/discord/bind/info/${accountId}`)
}
